// --------------------------------------------------------
// MyCareline - MyCareline
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
import { CircularProgress } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import ContainerWithSidebar from "../../../components/UI/containerWithSidebar/ContainerWithSidebar";
import CardPeriodic from "../../../components/cardPeriodic/CardPeriodic";
import MarkConsultButton from "../../../components/MarkConsultButton/MarkConsultButton";
import { GeneralContainer, H1, Text } from "../../../components/UI/generalLayout/Layout.styled";
import ScreenHeader from "../../../components/UI/screenHeader/ScreenHeader";
import { Spacer } from "../../../components/UI/spacer/spacer";
import { PersonService } from "../../../core/http/service/PersonService";
import useResponsiveInfo from "../../../hooks/useResponsiveInfo";
import {
  ButtonNotification,
  ContainerRow,
  HeaderInformation,
} from "../periodics/MyPeriodics.styled";
// --------------------------------------------------------
// MyCareline INTERFACE
// --------------------------------------------------------
/**
 * A component that renders a Screen.
 *
 * @param props Properties
 * @param props.route The route
 * @param props.navigation The navigator
 * @returns The component JSX.
 */
function MyCareline(): JSX.Element {
  // --------------------------------------------------------
  // MyCareline PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const [myCareLines, setMyCareLines] = useState<any[]>([])
  const [showModalScheduling, setShowModalScheduling] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const { isMobile } = useResponsiveInfo();
  const fetchCareLines = useCallback(async () => {
    const service: PersonService = new PersonService();
    const careLines: any[] = []
    try{
      const result: any = await service.getMyCareLines();
      result.data.data.forEach((d: any) => {
        careLines.push(d)
      })
      setMyCareLines(careLines)
    }catch(error: any){

    }
    setIsLoading(false)
  }, [])

  useEffect(() => {
    fetchCareLines();
  }, [])

  return (
    <ContainerWithSidebar>
      <GeneralContainer>
        <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", justifyContent: "space-between", alignItems: isMobile ? "flex-start" : "center", gap: "16px", marginBottom: "24px", width: "100%" }}>
          <H1 style={{ color: "#0F172A", fontWeight: 700, fontSize: "22px", display: "flex", alignItems: "center", gap: "10px", margin: 0 }}>
            <span style={{ width: 4, height: 22, background: "#0A5190", borderRadius: 2, display: "inline-block" }}></span>
            <span>Minhas Linhas de Cuidado</span>
          </H1>
          <MarkConsultButton />
        </div>
        {isLoading ? (<div style={{ textAlign: 'center', marginTop: 100 }}>
          <CircularProgress />
        </div>) : (<>
          {!isMobile && (<HeaderInformation>
            <Text bold={true}>Nome</Text>
            <Text
              style={{
                marginLeft: "5%",
              }}
              bold={true}
            >
              Data prevista
            </Text>
            <Text bold={true}>Próximos exames</Text>
          </HeaderInformation>)}
          {myCareLines.map(cl => {
            return <CardPeriodic title={cl.nome} data={cl} isCareLine={true} />
          })}
          {myCareLines.length === 0 && (<Text>Nenhum resultado encontrado</Text>)}
        </>)}
        <Spacer bottom={20} />
      </GeneralContainer>
    </ContainerWithSidebar>
  );
}

export default MyCareline;
